import React from 'react';
import { XCircle, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const PaymentCancelPage = () => {
  return (
    <div className="min-h-screen bg-[#050506] flex items-center justify-center p-4">
      {/* Background */}
      <div className="fixed inset-0 pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-[500px] h-[500px] bg-red-500/[0.03] rounded-full blur-[150px]" />
        <div className="absolute bottom-1/4 right-1/4 w-[400px] h-[400px] bg-amber-500/[0.03] rounded-full blur-[120px]" />
      </div>

      <div className="relative z-10 w-full max-w-lg">
        {/* Glow */}
        <div className="absolute -inset-2 bg-gradient-to-r from-zinc-500/20 via-zinc-400/30 to-zinc-500/20 rounded-3xl blur-2xl" />

        {/* Card */}
        <div className="relative bg-gradient-to-b from-zinc-900 to-zinc-950 rounded-2xl p-8 sm:p-10 border border-zinc-800 text-center">
          <div className="w-20 h-20 rounded-full bg-zinc-800 flex items-center justify-center mx-auto mb-6">
            <XCircle className="w-10 h-10 text-zinc-400" />
          </div>
          
          <h1 className="text-2xl font-black text-white mb-3">Оплата отменена</h1>
          <p className="text-zinc-400 mb-8">
            Вы отменили процесс оплаты. Если у вас возникли вопросы или проблемы, свяжитесь с нами.
          </p>

          <div className="space-y-4">
            <Link 
              to="/#pricing"
              className="w-full inline-flex items-center justify-center gap-3 px-8 py-4 bg-gradient-to-r from-amber-500 to-orange-500 text-black font-bold rounded-xl hover:shadow-lg hover:shadow-amber-500/30 hover:-translate-y-0.5 transition-all"
            >
              <span>Выбрать тариф</span>
              <ArrowRight className="w-5 h-5" />
            </Link>

            <Link 
              to="/"
              className="w-full inline-flex items-center justify-center gap-2 px-8 py-3 text-zinc-400 hover:text-white transition-colors"
            >
              <span>Вернуться на главную</span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancelPage;
